import axios from "../../../axios";
import download from "downloadjs";

export const getJsonData = async (bot_id, version_number) => {
  try {
    let { data } = await axios.get(
      `${process.env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/json/?bot_id=${bot_id}&version_number=${version_number}`,
    );
    return data;
  } catch (e) {
    console.log("errors", e);
  }
};
